import { render, staticRenderFns } from "./SubscriptionsTablePlan.vue?vue&type=template&id=97dd3126&scoped=true&"
import script from "./SubscriptionsTablePlan.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionsTablePlan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97dd3126",
  null
  
)

export default component.exports